<template>
  <transition appear name="fade">
    <div>
      <appHeader></appHeader>
      <div class="container-fluid p-3 product-page">
        <div class="row justify-content-center">
          <div v-if="product" class="col-12 col-lg-10 row mx-0 bp-product-layout">

            <!-- Left: image -->
            <div class="col-12 col-lg-5 bp-img-col">
              <div class="bp-img-card">
                <a href="#bp-lightbox" class="bp-img-wrap">
                  <img :alt="product.name" :src="product.imageUrl" class="bp-main-img" />
                  <div class="bp-img-zoom-hint">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>
                    Click to zoom
                  </div>
                </a>
              </div>
              <!-- lightbox -->
              <a id="bp-lightbox" class="lightbox" href="#">
                <img :alt="product.name" :src="product.imageUrl" />
              </a>
            </div>

            <!-- Right: details -->
            <div class="col-12 col-lg-7 bp-detail-col">
              <div class="bp-detail-card">

                <!-- Product name -->
                <h2 class="bp-product-name">{{ product.name }}</h2>

                <form v-on:submit.prevent="">

                  <!-- Version selector -->
                  <div v-if="product.versions.length > 1" class="bp-version-section">
                    <div class="bp-version-label">{{ currentProductVersion.specName }}</div>
                    <div class="bp-version-group">
                      <label
                        v-for="version in product.versions"
                        :key="version.id"
                        :class="{ 'bp-version-btn--active': version.id === currentProductVersion.id }"
                        class="bp-version-btn"
                      >
                        <input :value="version.id" type="radio" v-on:click="chooseVersion(version.id)" style="display:none" />
                        {{ version.specValue }}
                      </label>
                    </div>
                  </div>

                  <!-- CTA -->
                  <div class="bp-cta-row">
                    <router-link :to="{ name: 'Bonus Checkout' }" class="bp-cta-link">
                      <button class="bp-cta-btn" type="button">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
                        Get it now
                      </button>
                    </router-link>
                  </div>

                  <!-- Trust note -->
                  <div class="bp-trust-note">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                    All sales are final after selection and order placement
                  </div>

                </form>
              </div>
            </div>

            <!-- Description -->
            <div class="col-12 bp-desc-section">
              <div class="bp-desc-card">
                <div class="bp-desc-header">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="8"/><line x1="12" y1="12" x2="12" y2="16"/></svg>
                  Product information
                </div>
                <div class="bp-desc-body" v-html="product.description"></div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <appFooter></appFooter>
    </div>
  </transition>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { mapState } from 'vuex'

export default {
  props: {
    productId: Number
  },
  watch: {
    productId: function (newValue, oldValue) {
      this.productId = newValue
      this.$store.dispatch('product/fetchBonusPointsProductDetails', this.productId)
    },
    product: function (newValue, oldValue) {
      this.chooseVersion(newValue.versions[0].id)
    },
  },
  data () {
    return {
      chosenProductVersion: undefined,
      quantitySelected: 1,
    }
  },
  computed: {
    ...mapState({
      grossUpTaxes: state => state.company.grossUpTaxes,
      currentCategoryId: state => state.category.currentCategoryId,
      product: state => state.product.bonusPointsDetails,
      defaultProductVersion: state => state.product.bonusPointsDetails.versions[0],
      wishlistItems: state => state.wishlist.items
    }),
    currentProductVersion: function () {
      return this.chosenProductVersion || this.defaultProductVersion
    },
  },
  methods: {
    chooseVersion: function (versionId) {
      this.chosenProductVersion = this.product.versions.find(item => item.id === versionId)
      this.$store.dispatch('product/setChosenProductVersion', {
        productId: this.product.id,
        productVersionId: this.chosenProductVersion.id,
      })
    },
  },
  components: {
    appHeader: Header,
    appFooter: Footer,
  },
  created () {
    if (this.productId) {
      this.$store.dispatch('product/fetchBonusPointsProductDetails', this.productId)
          .then(() => {
                this.$store.dispatch('product/setChosenProductVersion', {
                  productId: this.productId,
                  productVersionId: this.defaultProductVersion.id,
                })
              }
          )
    }
  }
}
</script>

<style lang="scss">

/* ── Page background ── */
body { background-color: $white; }

/* ── Layout ── */
.bp-product-layout {
  padding: 1.5rem 0;
  gap: 0;
}

.bp-img-col {
  padding: 0 1rem 1rem 0;
}

.bp-detail-col {
  padding: 0 0 1rem 0;
}

/* ── Image card ── */
.bp-img-card {
  background: #fff;
  border: 1px solid $gray-200;
  border-radius: 14px;
  overflow: hidden;
  position: sticky;
  top: 80px;
}

.bp-img-wrap {
  display: block;
  position: relative;
  padding: 1.5rem;
  text-align: center;

  &:hover .bp-img-zoom-hint {
    opacity: 1;
  }
}

.bp-main-img {
  max-width: 100%;
  max-height: 380px;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  border-radius: $border-radius-sm;
  transition: transform 0.3s ease;

  &:hover { transform: scale(1.03); }
}

.bp-img-zoom-hint {
  position: absolute;
  bottom: 12px;
  right: 12px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: rgba(0,0,0,0.55);
  color: #fff;
  font-size: 11.5px;
  padding: 4px 10px;
  border-radius: 20px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

/* ── Lightbox (unchanged logic) ── */
.lightbox {
  display: none;
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  text-align: center;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.85);

  img {
    max-width: 90%;
    max-height: 80%;
    margin-top: 10%;
    border-radius: $border-radius-sm;
  }

  &:target {
    outline: none;
    display: block;
  }
}

/* ── Detail card ── */
.bp-detail-card {
  background: #fff;
  border: 1px solid $gray-200;
  border-radius: 14px;
  padding: 1.5rem;
  height: 100%;
}

.bp-product-name {
  font-size: 1.35rem;
  font-weight: 600;
  color: $gray-900;
  line-height: 1.35;
  margin: 0 0 1.25rem;

  &::after { display: none; }
}

/* ── Version selector ── */
.bp-version-section {
  margin-bottom: 1.25rem;
}

.bp-version-label {
  font-size: 12px;
  font-weight: 600;
  color: $gray-600;
  text-transform: uppercase;
  letter-spacing: .05em;
  margin-bottom: .6rem;
}

.bp-version-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.bp-version-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  border: 1.5px solid $gray-300;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: $gray-700;
  background: #fff;
  cursor: pointer;
  transition: all .15s ease;
  user-select: none;

  &:hover {
    border-color: #F8A355;
    color: #F8A355;
  }

  &--active {
    border-color: #F8A355;
    background: rgba(248, 163, 85, 0.08);
    color: #F8A355;
    font-weight: 600;
  }
}

/* ── CTA ── */
.bp-cta-row {
  margin-bottom: 1rem;
}

.bp-cta-link {
  text-decoration: none;
  display: block;
}

.bp-cta-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  background: #F8A355;
  border: none;
  border-radius: 10px;
  padding: 13px 24px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: background .15s ease, transform .1s ease;

  &:hover {
    background: darken(#F8A355, 8%);
    transform: translateY(-1px);
  }

  &:active { transform: scale(0.98); }
}

/* ── Trust note ── */
.bp-trust-note {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: $gray-700;
  background: $gray-100;
  border-radius: 6px;
  padding: 6px 12px;
  width: 100%;
}

/* ── Description ── */
.bp-desc-section {
  padding: 0;
  margin-top: 1rem;
}

.bp-desc-card {
  background: #fff;
  border: 1px solid $gray-200;
  border-radius: 14px;
  overflow: hidden;
}

.bp-desc-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: .85rem 1.25rem;
  border-bottom: 1px solid $gray-200;
  font-size: 14px;
  font-weight: 600;
  color: $gray-800;
  background: $gray-100;
}

.bp-desc-body {
  padding: 1.25rem;
  font-size: 13.5px;
  color: $gray-700;
  line-height: 1.7;
  column-count: 2;
  column-gap: 2.5rem;
  column-width: 150px;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .bp-img-col { padding: 0 0 1rem 0; }
  .bp-detail-col { padding: 0; }
  .bp-desc-body { column-count: 1; }
  .bp-detail-card { border-radius: 12px; padding: 1.25rem; }
  .bp-img-card { border-radius: 12px; }
}

/* ── Keep existing modal styles ── */
.modal-body, .modal-header {
  .border-right { border-width: 2px !important; }
  .thumbnail { max-width: 90% !important; }
  h5 { color: $success; }
  h5, h4, h3 { &::after { display: none; } }
}
.sm-modal { font-size: 1.2em; font-weight: 600; }
.modal-body { padding: 1rem 2rem !important; text-align: center; }
.modal-header {
  .btn-white { background: $white; border: 0; box-shadow: none; }
}
.btn-primary { background-color: #F8A355 !important; }

/* ── Alert (keep existing) ── */
.alert-event {
  position: fixed;
  top: 15%;
  z-index: 1000;
  margin: auto;
}
</style>